<div class="chat-input-container" data-testid="chat-input-container">
	<!-- Hidden file input -->
	<input #fileInputRef type="file" accept=".pdf,.docx,.txt,.md" (change)="onFileSelected($event)" class="hidden-file-input" aria-hidden="true" data-testid="chat-input-input-file" />

	<!-- File error message -->
	@if (fileError) {
		<div class="file-error" role="alert" data-testid="chat-input-panel-file-error">
			<mat-icon>error_outline</mat-icon>
			<span>{{ fileError }}</span>
		</div>
	}

	<!-- Attached file chip -->
	@if (attachedFile) {
		<div class="file-chip-container" data-testid="chat-input-panel-file-chip">
			<div class="file-chip">
				<mat-icon class="file-icon">description</mat-icon>
				<span class="file-name">{{ attachedFile.name }}</span>
				<span class="file-size">{{ formatFileSize(attachedFile.size) }}</span>
				<button type="button" class="remove-file-btn" (click)="removeFile()" aria-label="Remove attached file" data-testid="chat-input-btn-remove-file">
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>
	}

	<div class="input-wrapper">
		<!-- Attach button -->
		@if (!hideAttach) {
			<app-button variant="icon" category="action" iconName="attach_file" [tooltip]="attachTooltip" [onClick]="onAttachClick"></app-button>
		}

		<textarea
			#textareaRef
			[(ngModel)]="messageText"
			(keydown)="onKeyDown($event)"
			(input)="onInput()"
			[disabled]="disabled"
			placeholder="Ask a question..."
			class="message-input"
			rows="1"
			aria-label="Type your message"
			data-testid="chat-input-textarea-message"
		></textarea>

		<button class="send-btn" (click)="onSend()" [disabled]="!canSend()" [class.active]="canSend()" aria-label="Send message" data-testid="chat-input-btn-send">
			<mat-icon>arrow_upward</mat-icon>
		</button>
	</div>
	<p class="ai-disclaimer" data-testid="chat-input-ai-disclaimer">AI may make mistakes. Please double-check responses.</p>
</div>
